export default __webpack_public_path__ + "static/media/fantasy-land-static-template.2e687c28.png";